import Vue from "vue";
import Router from "vue-router";
//
const Main = () => import("@/components/pages/Main")
const Rules = () => import("@/components/pages/Rules")
const Partners = () => import("@/components/pages/Partners")
const Reviews = () => import("@/components/pages/Reviews")
const Cabinet = () => import("@/components/pages/Cabinet")
const Referal = () => import("@/components/pages/Referal")
const Logout = () => import("@/components/pages/Logout")
const TransactionNew = () => import("@/components/pages/TransactionNew")
const TransactionVerify = () => import("@/components/pages/TransactionVerify")
const TransactionPay = () => import("@/components/pages/TransactionPay")
const Transaction = () => import("@/components/pages/Transaction")
//
Vue.use(Router);
import store from "../store";
//
import { getTransaction } from "@/api";

const transactionRouteGuard = function transactionRouteGuard(to, from, next) {
  getTransaction(to.params.id)
    .then(res => res.data)
    .then(data => {
      let curStep = "/" + to.path.split("/")[1] + "/";
      let status = data.result.status;
      let path = `${to.params.id}`;
      let step;
      switch (status) {
        case 0:
          step = "/pay/";
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          step = "/get/";
          break;
        case 5:
          step = "/verify/";
          break;
        default:
          step = "/get/";
          break;
      }
      if (step !== curStep) {
        next(step + path);
      } else {
        next();
      }
    });
};

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main
    },
    {
      path: "/new",
      name: "NewTransaction",
      component: TransactionNew
    },
    {
      path: "/verify/:id",
      name: "VerifyTransaction",
      component: TransactionVerify,
      beforeEnter: transactionRouteGuard
    },
    {
      path: "/pay/:id",
      name: "PayTransaction",
      component: TransactionPay,
      beforeEnter: transactionRouteGuard
    },
    {
      path: "/get/:id",
      name: "GetTransaction",
      component: Transaction,
      beforeEnter: transactionRouteGuard
    },
    // {
    //   path: '/contacts',
    //   name: 'Contacts',
    //   component: Contacts
    // },
    {
      path: "/rules",
      name: "Rules",
      component: Rules
    },
    {
      path: "/partners",
      name: "Partners",
      component: Partners
    },
    {
      path: "/reviews",
      name: "Reviews",
      component: Reviews
    },
    {
      path: "/cabinet",
      name: "Cabinet",
      component: Cabinet,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("Auth") == null) {
          if (from.name === null) next({ name: "Main" });
          else {
            next({ name: from.name });
          }
        } else {
          next();
        }
      }
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    },
    {
      path: "/referal/:id",
      name: "Referal",
      component: Referal
    },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: AboutMain
    // },
    {
      path: "/about",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js